var _path, _path2, _path3, _path4, _path5, _rect, _path6, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9967 67.1913C47.8469 67.2003 47.7635 67.0201 47.8697 66.9139C60.0497 54.7339 79.7974 54.7339 91.9774 66.9139C104.157 79.0939 104.157 98.8416 91.9774 111.022C87.8115 115.187 82.7604 117.929 77.4296 119.245C75.6429 119.686 74.5303 117.519 75.575 116.004C83.9544 103.853 82.7388 87.0806 71.9283 76.2701C65.3606 69.7023 56.5923 66.6761 47.9967 67.1913Z",
    fill: "url(#paint0_linear_1772_21381)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9967 67.1913C47.8469 67.2003 47.7635 67.0201 47.8697 66.9139C60.0497 54.7339 79.7974 54.7339 91.9774 66.9139C104.157 79.0939 104.157 98.8416 91.9774 111.022C87.8115 115.187 82.7604 117.929 77.4296 119.245C75.6429 119.686 74.5303 117.519 75.575 116.004C83.9544 103.853 82.7388 87.0806 71.9283 76.2701C65.3606 69.7023 56.5923 66.6761 47.9967 67.1913Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.96 80.1527C60.951 80.3025 61.1313 80.3859 61.2375 80.2798C73.4175 68.0997 73.4175 48.352 61.2375 36.172C49.0574 23.992 29.3097 23.992 17.1297 36.172C12.9639 40.3379 10.2229 45.3889 8.90666 50.7197C8.46551 52.5064 10.6327 53.6191 12.1477 52.5743C24.2989 44.195 41.0708 45.4106 51.8813 56.221C58.4491 62.7888 61.4753 71.5571 60.96 80.1527Z",
    fill: "url(#paint1_linear_1772_21381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.96 80.1527C60.951 80.3025 61.1313 80.3859 61.2375 80.2798C73.4175 68.0997 73.4175 48.352 61.2375 36.172C49.0574 23.992 29.3097 23.992 17.1297 36.172C12.9639 40.3379 10.2229 45.3889 8.90666 50.7197C8.46551 52.5064 10.6327 53.6191 12.1477 52.5743C24.2989 44.195 41.0708 45.4106 51.8813 56.221C58.4491 62.7888 61.4753 71.5571 60.96 80.1527Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5926 91.2883C85.6687 87.9723 93.2344 83.0354 99.7925 76.4773C117.586 58.6836 123.446 33.4714 117.375 10.7771C94.6808 4.70668 69.4686 10.566 51.6749 28.3597C45.1169 34.9178 40.1799 42.4836 36.8639 50.5596L77.5926 91.2883Z",
    fill: "url(#paint2_linear_1772_21381)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.3125,
    y: 46,
    width: 60.3075,
    height: 16,
    rx: 4,
    transform: "rotate(45 38.3125 46)",
    fill: "#0E1214"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8472 50.1855C67.807 47.4752 71.2458 46.2701 74.4686 47.1642L76.2563 47.6601C78.962 48.4107 81.076 50.5248 81.8266 53.2304L82.2914 54.9057C83.2008 58.1837 81.9377 61.6783 79.1427 63.6174L46.4509 86.2977C45.3381 87.0697 43.8323 86.9347 42.8746 85.977C41.9023 85.0047 41.7797 83.4703 42.5854 82.356L65.8472 50.1855Z",
    fill: "url(#paint3_linear_1772_21381)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3164,
    cy: 36.1723,
    r: 7.56094,
    transform: "rotate(45 93.3164 36.1723)",
    fill: "#74FFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3151,
    cy: 36.1723,
    r: 9.56094,
    transform: "rotate(15 93.3151 36.1723)",
    stroke: "url(#paint4_linear_1772_21381)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_21381",
    x1: 107.466,
    y1: 91.8569,
    x2: 31.2253,
    y2: 73.3498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_21381",
    x1: 36.2944,
    y1: 20.683,
    x2: 54.8015,
    y2: 96.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1772_21381",
    x1: 80.933,
    y1: 65.2308,
    x2: 78.788,
    y2: -5.55528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1772_21381",
    x1: 68.6823,
    y1: 47.3271,
    x2: 85.7527,
    y2: 72.1361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1772_21381",
    x1: 96.1454,
    y1: 40.0377,
    x2: 87.0805,
    y2: 29.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.988bcf1f9d7895e19a42534245c693f5.svg";
export { ForwardRef as ReactComponent };